// Color swatch functionality
(function() {
  function initColorSwatches() {
    document.querySelectorAll('.color-swatch-wrapper').forEach(wrapper => {
      const optionIndex = parseInt(wrapper.dataset.optionIndex);
      const header = wrapper.querySelector('.swatch-label');
      
      // Get the form that contains this swatch
      const form = wrapper.closest('form');
      if (!form) return;
      
      wrapper.addEventListener('click', (e) => {
        const swatch = e.target.closest('.color-swatch');
        if (!swatch || swatch.disabled) return;
        
        const value = swatch.dataset.value;
        
        // Update UI
        wrapper.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        header.textContent = `Color: ${value}`;
        
        // Find the master selector and current selections
        const masterSelector = form.querySelector('#ProductSelect');
        if (!masterSelector) return;
        
        // Get all current option selections
        const currentSelections = {};
        form.querySelectorAll('.color-swatch-wrapper, .single-option-selector__radio').forEach(optionContainer => {
          const containerIndex = parseInt(optionContainer.dataset.optionIndex);
          if (optionContainer.classList.contains('color-swatch-wrapper')) {
            const selectedSwatch = optionContainer.querySelector('.color-swatch.selected');
            if (selectedSwatch) {
              currentSelections[`option${containerIndex}`] = selectedSwatch.dataset.value;
            }
          } else {
            const select = optionContainer.querySelector('select');
            if (select) {
              currentSelections[`option${containerIndex}`] = select.value;
            }
          }
        });
        
        // Update currentSelections with the new color value
        currentSelections[`option${optionIndex}`] = value;
        
        // Find the matching variant option
        const matchingOption = Array.from(masterSelector.options).find(option => {
          return Object.entries(currentSelections).every(([key, value]) => {
            return option.getAttribute(`data-${key}`) === value;
          });
        });
        
        if (matchingOption && !matchingOption.disabled) {
          // Update the master selector
          masterSelector.value = matchingOption.value;
          
          // Create and dispatch a change event
          const changeEvent = new Event('change', { bubbles: true });
          masterSelector.dispatchEvent(changeEvent);
        }
      });
    });
  }

  // Initialize on page load and after Shopify's section load
  document.addEventListener('DOMContentLoaded', initColorSwatches);
  document.addEventListener('shopify:section:load', initColorSwatches);
})(); 